import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed',
          {
            // Variants
            'bg-white text-slate-950 hover:shadow-[0_0_40px_-10px_rgba(255,255,255,0.3)]':
              variant === 'primary',
            'bg-slate-800/30 border border-white/10 hover:bg-slate-800/50 hover:border-white/20 text-white backdrop-blur-sm':
              variant === 'secondary',
            'border border-white/10 hover:border-primary/50 hover:bg-primary/10 text-white':
              variant === 'outline',
            'text-slate-400 hover:text-white hover:bg-white/5':
              variant === 'ghost',
            // Sizes
            'px-4 py-2 text-sm': size === 'sm',
            'px-6 py-3 text-base': size === 'md',
            'px-8 py-4 text-lg': size === 'lg',
          },
          className
        )}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
